import { ReactNode } from 'react';

import { FundRuleId } from '@/data/fundRulesDeclarations';

/* Glyphs for the fund rules, in their own file so that FundRulesGrid exports nothing but its
   component (react-refresh/only-export-components).

   They follow the stroke style of the icons in assets/icons - 24 grid, 1.5 stroke, round caps -
   and draw with currentColor so each one takes the site's wine tone. */
export const strokeProps = {
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  fill: 'none',
};

/** The document-with-a-check that titles both screens showing these rules. */
export const rulesIcon = (
  <>
    <path d="M14 3.5H7.5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V8L14 3.5Z" {...strokeProps} />
    <path d="M13.75 3.75V8h4.25" {...strokeProps} />
    <path d="M8.75 13.5 11 15.75l4-4.25" {...strokeProps} />
  </>
);

export const ruleIcons: Record<FundRuleId, ReactNode> = {
  // A gift box struck through: no consideration may be given for a donation.
  consideration: (
    <>
      <path d="M4.75 9.75h14.5v9.5a1 1 0 0 1-1 1H5.75a1 1 0 0 1-1-1v-9.5Z" {...strokeProps} />
      <path d="M3.75 6.25h16.5v3.5H3.75z" {...strokeProps} />
      <path d="M12 6.25v14" {...strokeProps} />
      <path d="M4.5 20.5 19.5 4.5" {...strokeProps} />
    </>
  ),
  // A phone struck through: no telemarketing.
  telemarketing: (
    <>
      <path d="M9 3.25h6a1.75 1.75 0 0 1 1.75 1.75v14a1.75 1.75 0 0 1-1.75 1.75H9A1.75 1.75 0 0 1 7.25 19V5A1.75 1.75 0 0 1 9 3.25Z" {...strokeProps} />
      <path d="M10.75 6h2.5" {...strokeProps} />
      <path d="M4.5 20.5 19.5 4.5" {...strokeProps} />
    </>
  ),
  // A shield with a check: undertaking to comply with the rules.
  compliance: (
    <>
      <path d="M12 3.25l7 2.5v5.6c0 4.35-2.9 7.7-7 9.15-4.1-1.45-7-4.8-7-9.15V5.75l7-2.5Z" {...strokeProps} />
      <path d="M9 12.15 11.25 14.4l4-4.3" {...strokeProps} />
    </>
  ),
  // A warning triangle: what happens if the rules are not met.
  breach: (
    <>
      <path d="M20.1 20.75H3.9c-1.55 0-2.52-1.68-1.75-3.02l8.1-14.08a2 2 0 0 1 3.49 0l8.1 14.08c.78 1.34-.2 3.02-1.74 3.02Z" {...strokeProps} />
      <path d="M12 9.15v4" {...strokeProps} />
      <circle cx="12" cy="16.75" r="1" fill="currentColor" />
    </>
  ),
};
